import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { B2B_Invoice_list } from "../type/b2bType";
import B2BInvoiceTableRow from "./B2BInvoiceTableRow";

const B2BInvoiceTable = ({
	invoiceList,
	loading,
	paginationSkip,
}: {
	invoiceList: B2B_Invoice_list[];
	loading: boolean;
	paginationSkip: number;
}) => {
	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Sl.</TableCell>
						<TableCell>Invoice Date</TableCell>
						<TableCell>Invoice No.</TableCell>
						<TableCell>Organization</TableCell>
						<TableCell>Phone</TableCell>
						<TableCell>Amount</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Action</TableCell>
					</TableRow>
				</TableHead>

				{loading ? (
					<TableLoader />
				) : invoiceList?.length ? (
					<TableBody>
						{invoiceList?.map((invoice, index) => (
							<B2BInvoiceTableRow
								key={invoice.id}
								invoice={invoice}
								index={index}
								paginationSkip={paginationSkip}
							/>
						))}
					</TableBody>
				) : (
					<TableNotFound />
				)}
			</Table>
		</TableContainer>
	);
};

export default B2BInvoiceTable;
